import { useState, useEffect } from 'react';
import { fetchVehicles, createVehicle } from '../api/vehicles';
import { validateVehicle } from '../validators/vehicle';

export const useVehicles = (axiosInstance, onError) => {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadVehicles = async () => {
    setLoading(true);
    try {
      const vehicles = await fetchVehicles(axiosInstance);
      setVehicles(vehicles);
    } catch (error) {
      onError(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateVehicle = async (vehicleData) => {
    const errors = validateVehicle(vehicleData);
    if (Object.keys(errors).length > 0) {
      onError('Por favor complete todos los campos requeridos');
      return false;
    }

    try {
      await createVehicle(axiosInstance, vehicleData);
      await loadVehicles();
      return true;
    } catch (error) {
      onError(error.message);
      return false;
    }
  };

  useEffect(() => {
    loadVehicles();
  }, []);

  return {
    vehicles,
    loading,
    loadVehicles,
    handleCreateVehicle
  };
}; 